/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityDashboardCompliance {
    getFixupPrototypeFunction() { return SecurityDashboardCompliance.fixupPrototype; }

    static newInstance(model: Partial<SecurityDashboardCompliance>): SecurityDashboardCompliance {
        let obj = Object.assign(new SecurityDashboardCompliance(), model);
        SecurityDashboardCompliance.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityDashboardCompliance>): SecurityDashboardCompliance {
        if (!model) return null;
        return SecurityDashboardCompliance.newInstance(<SecurityDashboardCompliance> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityDashboardCompliance) {
        if (!obj) return;

        models.SecurityDashboardCompliance.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityDashboardCompliance): boolean {
        Object.setPrototypeOf(obj, SecurityDashboardCompliance.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.high) {
            models.SecurityDashboardComplianceSeverity.fixupPrototype(this.high);
        }
        if (this.medium) {
            models.SecurityDashboardComplianceSeverity.fixupPrototype(this.medium);
        }
        if (this.low) {
            models.SecurityDashboardComplianceSeverity.fixupPrototype(this.low);
        }
    }

    /**
     * Cloud Account Id
     */
    cloud_account_id: string;

    high: models.SecurityDashboardComplianceSeverity;

    medium: models.SecurityDashboardComplianceSeverity;

    low: models.SecurityDashboardComplianceSeverity;

}
